import { render, staticRenderFns } from "./Riskcomponents.vue?vue&type=template&id=3c1f75a4&"
import script from "./Riskcomponents.vue?vue&type=script&lang=js&"
export * from "./Riskcomponents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports